import React from 'react';
import { isEqual } from 'lodash';
import { PauseSelect } from '../PauseSelect';
import { PauseFormField2 } from './index';

type Props = {
  showErrorMessage?: boolean,
  label?: string,
  name: string,
  disabled?: boolean,
  fieldProps: {
    [key: string]: any
  }
};

export const PauseFormSelect = React.memo<Props>(({
  showErrorMessage,
  label,
  name,
  disabled,
  fieldProps,
}) => (
  <PauseFormField2
    name={name}
    disabled={disabled}
    showErrorMessage={showErrorMessage}
    fieldProps={fieldProps}
    render={({ field, state }) => (
      <PauseSelect
        {...state}
        {...field}
        value={field.value}
        label={label}
        TextfieldProps={{ ...state }}
        {...fieldProps}
      />
    )}
  />
),
(newProps, oldProps) => (isEqual(newProps, oldProps) && isEqual(newProps.fieldProps, oldProps.fieldProps)
));
